import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center py-12">
      {/* Patriotic background */}
      <div 
        className="fixed inset-0 opacity-5"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1563804846955-f87a66f0b20a?w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      ></div>
      <div className="fixed inset-0 bg-gradient-to-br from-slate-50 via-blue-50/40 to-red-50/40"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto">
          <Card className="text-center bg-white/90 backdrop-blur-sm">
            <CardContent className="p-12">
              <XCircle className="w-20 h-20 text-orange-500 mx-auto mb-4" />
              <h2 className="text-4xl font-bold text-slate-900 mb-4">Payment Cancelled</h2>
              <p className="text-xl text-slate-600 mb-6">
                Your payment was cancelled. No charges were made to your account.
              </p>
              
              <p className="text-slate-600 mb-8">
                You can return to checkout anytime to complete your purchase. Your cart items are still saved.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => navigate('/checkout')}
                  className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700"
                  size="lg"
                >
                  Return to Checkout
                </Button>
                <Button 
                  onClick={() => navigate('/cart')}
                  variant="outline"
                  size="lg"
                  className="border-2"
                >
                  View Cart
                </Button>
                <Button 
                  onClick={() => navigate('/')}
                  variant="ghost"
                  size="lg"
                >
                  Go Home
                </Button>
              </div>

              <div className="mt-8 pt-8 border-t">
                <p className="text-sm text-slate-600 mb-2">Need assistance?</p>
                <p className="font-semibold">Call: 205-587-2402</p>
                <p className="text-slate-600">Email: coastalflagco@yahoo.com</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;